import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardSection } from '@sm360/ui-library';
import { LocaleService } from '@sm360/widget-commons-core-services';

const ErrorMessage = ({ message }) => {
    return (
        <div className="API-error-msg">
            <Card color="alert" outline>
                <CardSection>
                    <icon className="icon-Warning" />
                    <p>{message || LocaleService.t('TRADE_IN.ERROR_FETCHING')}</p>
                </CardSection>
            </Card>
        </div>
    );
};

ErrorMessage.defaultProps = {
    message: '',
};

ErrorMessage.propTypes = {
    message: PropTypes.string,
};

ErrorMessage.displayName = 'ErrorMessage';

export default ErrorMessage;
